import { EvsbVirtualCheckupModel } from './evsb-virtual-checkup.model';
import { Injectable } from '@angular/core';

@Injectable()
export class EvsbVirtualCheckupMapper {
  public getModel(): EvsbVirtualCheckupModel {
    return {
      day1: undefined,
      day1Options: {
        morning: false,
        afternoon: false,
        evening: false,
      },
      day2: undefined,
      day2Options: {
        morning: false,
        afternoon: false,
        evening: false,
      },
      day3: undefined,
      day3Options: {
        morning: false,
        afternoon: false,
        evening: false,
      },
      vatNumber: '',
      company: '',
      firstName: '',
      lastName: '',
      telephone: '',
      email: '',
      alreadyClient: false,
      consent: false,
    };
  }
}
